var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgService4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 92,
    viewBox: "0 0 92 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_595_10807)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 80,
    height: 80,
    rx: 15,
    fill: "#D0A703"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.5 43.5C41.6867 43.5 42.8467 43.1481 43.8334 42.4888C44.8201 41.8295 45.5892 40.8925 46.0433 39.7961C46.4974 38.6997 46.6162 37.4933 46.3847 36.3295C46.1532 35.1656 45.5818 34.0965 44.7426 33.2574C43.9035 32.4182 42.8344 31.8468 41.6705 31.6153C40.5067 31.3838 39.3003 31.5026 38.2039 31.9567C37.1075 32.4109 36.1705 33.1799 35.5112 34.1666C34.8519 35.1533 34.5 36.3133 34.5 37.5C34.5 39.0913 35.1321 40.6174 36.2574 41.7426C37.3826 42.8679 38.9087 43.5 40.5 43.5ZM52.5 46.5C53.39 46.5 54.26 46.2361 55.0001 45.7416C55.7401 45.2471 56.3169 44.5443 56.6575 43.7221C56.9981 42.8998 57.0872 41.995 56.9135 41.1221C56.7399 40.2492 56.3113 39.4474 55.682 38.818C55.0526 38.1887 54.2508 37.7601 53.3779 37.5865C52.505 37.4128 51.6002 37.502 50.7779 37.8425C49.9557 38.1831 49.2529 38.7599 48.7584 39.4999C48.2639 40.24 48 41.11 48 42C48 43.1935 48.4741 44.3381 49.318 45.182C50.1619 46.0259 51.3065 46.5 52.5 46.5ZM58.5 57C58.8978 57 59.2794 56.842 59.5607 56.5607C59.842 56.2794 60 55.8978 60 55.5C59.9988 54.0981 59.6047 52.7246 58.8624 51.5353C58.1201 50.3461 57.0594 49.3886 55.8005 48.7717C54.5417 48.1548 53.1351 47.903 51.7404 48.045C50.3457 48.187 49.0187 48.717 47.91 49.575C46.4408 48.1115 44.5711 47.1159 42.5367 46.7136C40.5024 46.3114 38.3945 46.5205 36.4788 47.3147C34.5632 48.1089 32.9256 49.4525 31.7726 51.1762C30.6196 52.8998 30.0028 54.9263 30 57C30 57.3978 30.158 57.7794 30.4393 58.0607C30.7206 58.342 31.1022 58.5 31.5 58.5H49.5C49.8978 58.5 50.2794 58.342 50.5607 58.0607C50.842 57.7794 51 57.3978 51 57",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_595_10807",
    x: 0,
    y: 0,
    width: 92,
    height: 92,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_595_10807"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_595_10807"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_595_10807",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgService4);
export default __webpack_public_path__ + "static/media/service-4.ad3952fc50dcaad14f0c617433e16d52.svg";
export { ForwardRef as ReactComponent };